import { Injectable, inject, signal } from '@angular/core';
import { Actions, ofActionCompleted } from '@ngxs/store';
import type { DynamicFlatNode } from '../../../../../libs/commons/src';
import { db } from '../../app/db';
import { TreeStateActions } from '../../app/states/tree/tree.actions';

export interface ChannelInfo {
  id: string;
  name: string;
  color: string;
}

@Injectable({ providedIn: 'root' })
export class ChannelInfoService {
  private readonly actions = inject(Actions);
  /**
   *
   */
  channelInfo = signal<DynamicFlatNode[]>([]);

  constructor() {
    this.actions.pipe(ofActionCompleted(TreeStateActions.SaveFlatTree)).subscribe(() => {
      this.init();
    });
  }
  /**
   *
   */
  async init() {
    try {
      this.channelInfo.set(await db.channelInfo.toArray());
    } catch (error) {
      console.warn('Failed to fetch controls from IndexedDB, using store data instead', error);
    }
  }
}
